// extracted by mini-css-extract-plugin
module.exports = {"title":"SetMottoDialog_title_tS_Fd","content":"SetMottoDialog_content_Qaihf","submit":"SetMottoDialog_submit_xGxjq"};